// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import {ENDPOINT} from '@/shared/constants'
import {PERMISSIONS, WILDCARDBSON} from 'vue-common/components/constants'
import {AXIOSAPI} from '@/api/api'
import {checkPermission} from 'vue-common/components/user'

const state = {
  user: {},
  rules: []
}

const getters = {
  accessRules: state => state.rules,
  user: state => state.user,

  allCustomers: function (state, getters) {
    if (state.user.securityCtx) {
      if (state.user.securityCtx.customers) {
        return state.user.securityCtx.customers.includes(WILDCARDBSON)
      }
    }
    return false || getters.isSuperAdmin
  },

  isSuperAdmin: function (state) {
    return checkPermission(state.rules, WILDCARDBSON, PERMISSIONS.DELETE)
  }
}

const mutations = {
  setUser (state, user) {
    state.user = user
  },

  setRules (state, rules) {
    state.rules = rules
  }
}

const actions = {
  getUserData (context) {
    AXIOSAPI.get(ENDPOINT + 'users/me').then(response => {
      var user = response.data
      context.commit('setUser', user)
      var query = ''
      if (user.roles.length > 0) {
        query = query + user.roles[0]
      }
      for (var i = 1; i < user.roles.length; i++) {
        query = query + ','
        query = query + user.roles[i]
      }
      return AXIOSAPI.get(ENDPOINT + 'accessRules?roles=' + query).then(response => {
        context.commit('setRules', response.data)
      }).catch(e => {
        console.log(e)
      })
    }).catch(e => {
      console.log(e)
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js